/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MovementOnFundsReportFundOperationDtoDeposit
 */
export interface MovementOnFundsReportFundOperationDtoDeposit {
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportFundOperationDtoDeposit
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof MovementOnFundsReportFundOperationDtoDeposit
   */
  number: number;
  /**
   *
   * @type {Date}
   * @memberof MovementOnFundsReportFundOperationDtoDeposit
   */
  createdAt: Date;
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportFundOperationDtoDeposit
   */
  depositTypeName: string;
}

export function MovementOnFundsReportFundOperationDtoDepositFromJSON(
  json: any
): MovementOnFundsReportFundOperationDtoDeposit {
  return MovementOnFundsReportFundOperationDtoDepositFromJSONTyped(json, false);
}

export function MovementOnFundsReportFundOperationDtoDepositFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MovementOnFundsReportFundOperationDtoDeposit {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    createdAt: new Date(json["createdAt"]),
    depositTypeName: json["depositTypeName"],
  };
}

export function MovementOnFundsReportFundOperationDtoDepositToJSON(
  value?: MovementOnFundsReportFundOperationDtoDeposit | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    createdAt: value.createdAt.toISOString(),
    depositTypeName: value.depositTypeName,
  };
}
